import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';


/**
 * Generated class for the PinemployeehomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pinemployeehome',
  templateUrl: 'pinemployeehome.html',
})
export class PinemployeehomePage {
  priv: boolean = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private barcodeScanner: BarcodeScanner, public alertCtrl: AlertController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PinemployeehomePage');
    this.priv = this.gn.getPriv('barcodescanner')

  }

  presentAlert() {
    var _that = this
    let alert = this.alertCtrl.create({
      title: 'Barcode scanner',
      subTitle: _that.dic.l["novprivall"],
      buttons: [_that.dic.l['ok']]
    });
    alert.present();
  }


  Scan() {
    if (this.priv == false) {
      this.presentAlert()
    } else {

      var _that = this;
      this.barcodeScanner.scan().then(barcodeData => {
        // console.log('Barcode data', barcodeData.text);
        if (barcodeData.text != null && barcodeData.text != '') {
          console.log(barcodeData, 'barcodeData')
          alert(barcodeData.text)
          //   if (_that.order.barcode == barcodeData.text) {
          //     _that.orderSavePickuUp(barcodeData.text, 'fromBase')
          //   } else {
          //     let alert = _that.alertCtrl.create({
          //       title: 'Error!',
          //       subTitle: 'You scan wrong barcode !',
          //       buttons: ['OK']
          //     });
          //     alert.present();

          //   }
          // }


        }

      }).catch(err => {
        console.log('Error', err);
      });
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/pinemployeehome/pinemployeehome.ts